var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn",
    {
      staticClass: "q-mr-sm",
      attrs: { flat: "", dense: "", round: "", icon: "fal fa-bell" }
    },
    [
      _vm.getMessagesLength > 0
        ? _c(
            "q-chip",
            { attrs: { floating: "", "icon-right": "", color: "red" } },
            [_vm._v(_vm._s(_vm.getMessagesLength))]
          )
        : _vm._e(),
      _c(
        "q-popover",
        { style: { minWidth: "200px" } },
        [
          _c(
            "q-list",
            { attrs: { link: "", separator: "" } },
            [
              _vm._l(_vm.filteredMessages, function(message, index) {
                return _c(
                  "q-item",
                  {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    key: index,
                    nativeOn: {
                      click: function($event) {
                        return _vm.checkMessage(message)
                      }
                    }
                  },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("q-icon", {
                          attrs: {
                            name:
                              "far fa-" + _vm.getIconNotification(message.mt),
                            size: "1.5rem"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { label: "" } }, [
                          _vm._v(_vm._s(message.t))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _vm.getMessagesLength === 0
                ? _c(
                    "q-item",
                    [
                      _c(
                        "q-item-side",
                        [
                          _c("q-icon", {
                            attrs: { name: "far fa-ban", size: "1.5rem" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-item-main",
                        [
                          _c("q-item-tile", { attrs: { label: "" } }, [
                            _vm._v(_vm._s(_vm.$t("no_notification_avaliable")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_message,
            callback: function($$v) {
              _vm.show_message = $$v
            },
            expression: "show_message"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_message = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("span", {
                      staticStyle: { "max-width": "100%" },
                      domProps: { innerHTML: _vm._s(_vm.selected_message.b) }
                    })
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "far fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_message = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("mark_as_read"),
                            icon: "far fa-check"
                          },
                          on: {
                            click: function($event) {
                              return _vm.markAsRead(_vm.index)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_modal_badge,
            callback: function($$v) {
              _vm.show_modal_badge = $$v
            },
            expression: "show_modal_badge"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal_badge = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.badge.title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c("div", { staticClass: "col-xs-12 col-sm-3 badge" }, [
                    _c("img", {
                      class: _vm.getBadgeClass(_vm.badge),
                      attrs: { src: _vm.getBadgeImage(_vm.badge) }
                    })
                  ]),
                  _c("div", { staticClass: "col-xs-12 col-sm-9" }, [
                    _c("div", { staticClass: "q-display-1 q-mb-md" }, [
                      _vm._v(_vm._s(_vm.badge.title))
                    ]),
                    _c("p", [_vm._v(_vm._s(_vm.badge.description))]),
                    _vm.badge.earned_date
                      ? _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("earned_in")) +
                              ": " +
                              _vm._s(_vm.formatDate(_vm.badge.earned_date))
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("modal-stars", {
        attrs: {
          show: _vm.show_modal_star,
          course: _vm.course,
          read_only: true
        },
        on: { hideModal: _vm.hideModal }
      }),
      _c("modal-notification", {
        attrs: { show_modal: _vm.show_news, id: _vm.id_news },
        on: { hideModalNews: _vm.hideModalNews }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }